import { useQuery } from '@apollo/client';
import { useContext } from 'react';
import { adminInfoStoreQuery } from '../graphql/queries';
import {
  CanAccessPartnerData,
  ViewerContext,
} from '../providers/ViewerContextProvider';

interface IUrlParameters {
  match: {
    params: {
      storeId: string;
    };
  };
}

export default function SalesforceRedirect(urlParams: IUrlParameters) {
  const viewer = useContext(ViewerContext);
  const allowedToAccess = CanAccessPartnerData(viewer);
  const { storeId } = urlParams.match.params;
  useQuery(adminInfoStoreQuery, {
    fetchPolicy: 'no-cache',
    skip: storeId == null || !allowedToAccess,
    variables: { id: storeId },
    onCompleted: (storeData: any) => {
      if (storeData?.store?.external_salesforce_id) {
        window.location.href = `https://vytalglobalgmbh.lightning.force.com/lightning/r/Account/${storeData.store.external_salesforce_id}/view`;
      }
    },
  });
  return <div />;
}
